export default __webpack_public_path__ + "static/media/channel_galaxy_img_01@2x.a1c8a4ea.png";